// extracted by mini-css-extract-plugin
module.exports = {"delete":"FidAdminEmployees_delete__3SLG9","confirmLabel":"FidAdminEmployees_confirmLabel__3558a"};